import { render, staticRenderFns } from "./LevyCollectionTaskCard.vue?vue&type=template&id=639cd780&"
import script from "./LevyCollectionTaskCard.vue?vue&type=script&lang=js&"
export * from "./LevyCollectionTaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports